import { render, staticRenderFns } from "./CustomForm.vue?vue&type=template&id=477417ee&scoped=true&"
import script from "./CustomForm.vue?vue&type=script&lang=js&"
export * from "./CustomForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomForm.vue?vue&type=style&index=0&id=477417ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477417ee",
  null
  
)

export default component.exports